/**
 * AdminLayout.tsx  -  Shell for the platform_admin portal.
 */

import { Eye, LayoutDashboard, School, Settings, ShieldCheck } from "lucide-react";
import { PortalShell } from "./PortalShell";

export default function AdminLayout() {
  return (
    <PortalShell
      portalLabel="Platform admin"
      nav={[
        { to: "/admin", icon: LayoutDashboard, label: "Overview", end: true },
        { to: "/admin/schools", icon: School, label: "Schools" },
        { to: "/admin/sanctions", icon: ShieldCheck, label: "Sanctions checks" },
        { to: "/admin/impersonate", icon: Eye, label: "Preview a role" },
        { to: "/admin/settings", icon: Settings, label: "Settings" },
      ]}
    />
  );
}
